import { createContext, useContext } from "react";
const FieldAttributesContext = createContext(void 0);
function useFieldAttributes() {
  const context = useContext(FieldAttributesContext);
  if (typeof context === "undefined") {
    throw new Error(
      "useFieldAttributes must be used inside a <FieldAttributesContext.Provider>"
    );
  }
  return context;
}
export {
  FieldAttributesContext,
  useFieldAttributes
};
//# sourceMappingURL=field-attributes-context.js.map
